import { AuthDialog, UpgradeToSmartDialog } from '@ideoz/ui';

interface AuthDialogState {
  isOpen: boolean;
  mode: 'login' | 'register';
  isLoading: boolean;
  openRegister: () => void;
  openLogin: () => void;
  closeDialog: () => void;
  switchMode: (mode: 'login' | 'register') => void;
  handleLogin: (email: string, password: string) => Promise<void>;
  handleRegister: (name: string, email: string, password: string) => Promise<void>;
  handleGoogleAuth: () => Promise<void>;
  handleNavigateToForgotPassword: () => void;
}

interface PlanDetails {
  name?: string;
  features?: Array<{ name: string; maxLimit?: string | number }>;
}

interface ConversationDialogsProps {
  // Auth (web only)
  authDialogState?: AuthDialogState;

  // Upgrade to Smart
  isUpgradeToSmartOpen: boolean;
  onCloseUpgradeToSmart: () => void;
  onConfirmUpgradeToSmart: () => void;
  planDetails?: PlanDetails | null;
}

/** Dumb: the trailing modal cluster for the conversation page. */
export function ConversationDialogs({
  authDialogState,
  isUpgradeToSmartOpen,
  onCloseUpgradeToSmart,
  onConfirmUpgradeToSmart,
  planDetails,
}: ConversationDialogsProps): JSX.Element {
  const currentPlanProjects = (() => {
    const projectsFeature = planDetails?.features?.find((f) => f.name === 'Projects');
    if (!projectsFeature) return '1 Project';
    const maxLimit = projectsFeature.maxLimit;
    if (maxLimit === '1' || maxLimit === 1) return '1 Project';
    return `${maxLimit} Projects`;
  })();

  return (
    <>
      {authDialogState && (
        <AuthDialog
          isOpen={authDialogState.isOpen}
          mode={authDialogState.mode}
          onClose={authDialogState.closeDialog}
          onModeChange={authDialogState.switchMode}
          onLogin={authDialogState.handleLogin}
          onRegister={authDialogState.handleRegister}
          onGoogleAuth={authDialogState.handleGoogleAuth}
          isLoading={authDialogState.isLoading}
          onNavigateToForgotPassword={authDialogState.handleNavigateToForgotPassword}
        />
      )}

      <UpgradeToSmartDialog
        isOpen={isUpgradeToSmartOpen}
        onClose={onCloseUpgradeToSmart}
        onConfirm={onConfirmUpgradeToSmart}
        variant="project-limit"
        currentPlanName={planDetails?.name || 'Free'}
        currentPlanPrice="$0/month"
        currentPlanProjects={currentPlanProjects}
        upgradedPlanName="Smart"
        upgradedPlanPrice="$19/month"
      />
    </>
  );
}
